<template>
  <v-container class="primary-navigation grey lighten-5 title-bar" data-primary-navigation>
    <v-bottom-navigation color="primary" horizontal grow>
      <v-btn text :to="{ name: 'place-rules-manage', params: { placeId: $route.params.placeId } }">
        <span v-html="$t('global-terms.rules')"></span>
        <v-icon>mdi-gavel</v-icon>
      </v-btn>

      <v-btn v-if="currentUserHasRole('Administrator') || currentUserHasRole('Membership')" text :to="{ name: 'place-rates-manage', params: { placeId: $route.params.placeId } }">
        <span v-html="$t('global-terms.rates')"></span>
        <v-icon>mdi-cash-register</v-icon>
      </v-btn>

      <v-btn v-if="currentUserHasRole('Administrator') || currentUserHasRole('Membership')" text :to="{ name: 'place-extras-manage', params: { placeId: $route.params.placeId } }">
        <span v-html="$t('global-terms.extras')"></span>
        <v-icon>mdi-account-group</v-icon>
      </v-btn>

      <v-btn text :to="{ name: 'place-accommodation', params: { placeId: $route.params.placeId } }">
        <span v-html="$t('global-terms.accommodation')" class="mr-2"></span>
        <v-icon>mdi-list-status</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-container>
</template>
<script>
import { isNil } from 'ramda'
import { mapState } from 'pinia'
import { useUserStore } from '@/stores'

export default {
  name: 'place-menu-bar',
  methods: {
    isNil,
    stickyHeader () {
      const primaryNav = document.querySelector('[data-primary-navigation]')
      const header = document.querySelector('[data-header]')

      const options = {
        rootMargin: `${primaryNav.offsetHeight - 20}px`,
        threshold: 1.0,
      }

      const callback = (entries) => {
        if (!entries[0].isIntersecting) {
          primaryNav.classList.add('fixed')
        } else {
          primaryNav.classList.remove('fixed')
        }
      }

      const observer = new IntersectionObserver(callback, options)

      observer.observe(header)
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUserHasRole']),
  },
  mounted () {
    let int = setInterval(() => {
      if (document.querySelector('[data-header]') !== null) {
        this.stickyHeader()
        clearInterval(int)
      }
    }, 50)
  },
}
</script>

<style lang="scss" scoped>
.v-bottom-navigation {
  border-radius: 5px;
}

.primary-navigation.fixed {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  max-width: none;
  padding: 0;
  z-index: 4;
}
</style>
